import React from 'react';

import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import useRounds from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useRounds';

export default function Rounds() {
  const { availableIntervals, selectedRounds, setRounds } = useRounds();

  return (
    <Accordion.Item eventKey="forecastdate" id="forecastdate-accordion">
      <Accordion.Header>Rodadas</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          inline
          showMonthDropdown
          showYearDropdown
          selectsMultiple
          onChange={(dates) => setRounds(dates || [])}
          selectedDates={selectedRounds}
          includeDateIntervals={availableIntervals}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
